import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Page } from "../components/Layout.tsx";
import { BlendMeter, StampBadge, AvatarPair } from "../components/brand.tsx";
import { DevLogins } from "../components/DevLogins.tsx";
import { AuthButtons } from "../components/AuthButtons.tsx";
import { useAuth } from "../auth/AuthProvider.tsx";

export default function Landing() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!auth.loading && auth.user) navigate("/me", { replace: true });
  }, [auth.loading, auth.user, navigate]);

  return (
    <Page testid="screen-landing" wide>
      <div className="grid items-center gap-10 lg:grid-cols-2">
        <div>
          <p className="overline mb-3">Now showing · for two</p>
          <h1 className="font-display text-4xl font-extrabold leading-[1.05] tracking-tightish text-ink-900 sm:text-5xl">
            Two movie libraries, <span className="text-red-600">one screening.</span>
          </h1>
          <p className="mt-4 max-w-md text-lg text-ink-500">
            Bring your Letterboxd history. Share one link. When a friend joins, we blend your taste — what
            you both love, where you split, and exactly what to watch tonight.
          </p>
          <div className="mt-7 flex max-w-sm flex-col gap-3">
            <AuthButtons />
            <p className="mono-meta mt-1 normal-case tracking-normal text-ink-400">
              We only ever keep titles, years, ratings, and monthly totals. Nothing else.
            </p>
            <DevLogins />
          </div>
        </div>

        {/* Example blend ticket */}
        <div className="card flex flex-col items-center gap-4 bg-card">
          <div className="flex w-full items-center justify-between">
            <span className="overline">Example blend</span>
            <AvatarPair a={{ name: "You" }} b={{ name: "Liban" }} size={30} />
          </div>
          <BlendMeter value={82} size={150} label="Blend" />
          <StampBadge tone="gold">Perfect match</StampBadge>
          <div className="mt-1 grid w-full grid-cols-3 gap-3 text-center">
            {[
              ["214", "Shared"],
              ["40", "You clash"],
              ["6", "Tonight"],
            ].map(([n, l]) => (
              <div key={l} className="rounded-md bg-paper-100 p-3">
                <div className="stat-num text-xl">{n}</div>
                <div className="stat-label mt-0.5">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Page>
  );
}
